import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import Modal from '../../modal/modal.component'
import Button from '../../buttons/buttons.component'
import StyledChangeAddressModalBody from '../address-manager/styles/styled-change-address-modal-body.style'
import { addressFieldsSchema } from '../address-fields/address-fields.schema'
import { AddressFields } from '../address-fields/address-fields.component'
import { AddressFieldsHelper } from '../address-fields/address-fields.helper'
import { toastActions } from '../../../actions'
import { AddressService } from './../../../services/address.service'

const initialValues = {
	zipCode: '',
	street: '',
	number: '',
	complement: '',
	neighborhood: '',
	city: '',
	state: ''
}

class NewAddressModal extends Component {
	setFormData = form => data => AddressFieldsHelper.setFormData(form, data)

	resetForm = form => () =>
		AddressFieldsHelper.setFormData(form, initialValues)

	addAddress = addressValues => {
		const {
			addresses,
			danger,
			successToast,
			onClose,
			editingAddress,
			updateAddress
		} = this.props

		const isEdit = editingAddress !== null

		const isDuplicatedAddress = AddressFieldsHelper.isAddressDuplicated(
			addressValues,
			addresses
		)

		if (isDuplicatedAddress) {
			danger({ message: 'O endereço já existe' })
			return
		}

		addressValues.billingAddress = false

		if (isEdit) {
			const oldAddress = addresses.find(
				address => address.id === editingAddress
			)

			addressValues = Object.assign({}, oldAddress, addressValues)
		}

		AddressService.addOrUpdate(null, addressValues).then(({ success }) => {
			if (success) {
				successToast({
					message: `Endereço ${isEdit ? 'atualizado' : 'adicionado'}`
				})
				updateAddress(addressValues)
				onClose()
			}
		})
	}

	render() {
		const { isOpen, editingAddress, addresses, onClose } = this.props

		return (
			<Modal ref="newAddressModal" onClose={onClose} isOpen={isOpen} medium>
				<StyledChangeAddressModalBody>
					<div className="orange semi-bold f30">Adicionar endereço</div>
					<Formik
						initialValues={
							editingAddress !== null
								? addresses[editingAddress]
								: initialValues
						}
						validationSchema={addressFieldsSchema}
						ref="form"
						onSubmit={this.addAddress}
						render={props => (
							<form
								noValidate
								onSubmit={props.handleSubmit}
								style={{ width: '100%' }}>
								<AddressFields
									{...props}
									setFormData={this.setFormData(this.refs.form)}
									resetForm={this.resetForm(this.refs.form)}
									enabled={!!editingAddress}
								/>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										margin: '4rem auto 25px'
									}}>
									<Button
										danger
										type="button"
										onClick={() => this.refs.newAddressModal.close()}>
										Cancelar
									</Button>
									<Button
										primary
										type="submit"
										style={{ marginLeft: '15px' }}>
										Salvar
									</Button>
								</div>
							</form>
						)}
					/>
				</StyledChangeAddressModalBody>
			</Modal>
		)
	}
}

const mapDispatchToPros = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			warning: toastActions.warning,
			successToast: toastActions.success
		},
		dispatch
	)

const connectedNewAddressModal = connect(
	null,
	mapDispatchToPros
)(NewAddressModal)

export { connectedNewAddressModal as NewAddressModal }
